module.exports = __webpack_public_path__ + "static/img/quzheng01.d5142c39.png";